// services/index.ts
import { amosServices } from './amos';
import api from './api';
import { userServices } from './user';
import { errorHandler } from './error_handler';
import type { ErrorHandlerOptions } from './error_handler';
import { offlineStorage } from './offlineStorage';

const env = import.meta.env.VITE_APP_ENVIRONMENT || 'development';

// Type-safe service aggregator
export const apiService = {
  amos: amosServices(env, api, errorHandler),
  user: userServices(env, api, errorHandler),
} as const;

// Export individual services for tree-shaking
export { amosServices, userServices, api, errorHandler, offlineStorage };

// Type exports
export type ApiService = typeof apiService;
export type { ErrorHandlerOptions };
